(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["social-sharing"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', event => {
    const link = event.target.closest('a[data-share-method]');
    if (!link) return;
    const group = link.closest('.fmv-message-sharing');
    if (!group) return;
    const productInfo = group.closest('product-info');
    const variantId = productInfo?.querySelector('form.main-product-form [name="id"]')?.value;
    const url = new URL(group.dataset.shareUrl, location.origin);
    if (variantId) url.searchParams.set('variant', variantId);
    const title = group.dataset.shareTitle;
    const message = encodeURIComponent(title + ' — ' + url.href);
    if (link.dataset.shareMethod === 'whatsapp') link.href = 'https://wa.me/?text=' + message;
    if (link.dataset.shareMethod === 'email') link.href = 'mailto:?subject=' + encodeURIComponent(title) + '&body=' + message;
    if (link.dataset.shareMethod === 'sms') {
      const ios = /iPad|iPhone|iPod/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
      link.href = 'sms:' + (ios ? '&' : '?') + 'body=' + message;
    }
  });
  } catch(e) { console.error(e); }
})();

})();
